module.exports = __webpack_public_path__ + "img/C08_UnitTechWarElephantChampion_Normal_ua.edb08e14.webp";